import { ConvertFloat } from "@/composables/convertFloat"
const {convertFloat} = ConvertFloat()
export default {
    state: {
        calculeteBalance: 0,
        all: {
            alimony: 0,
            averageamountspentonhealthcare: 0,
            city: "",
            educationexpenditureindex: 0,
            extracurricularcourse: 0,
            familymembers: 0,
            healthtotal: 0,
            housingexpensesindex: 0,
            installmentorrent: 0,
            minimumwage: 1621.00,
            otherschoolsorcolleges: 0,
            percapitaincome: 0,
            percentageevaluated: "100",
            sacramentinas: 0,
            schooltransport: 0,
            totalfamilyincome: 0,
        },
        description: "",
    },
    getters: {
        getCalculete: (state) => {
            return state.calculeteBalance
        },
        getAll: (state) => {
            return state.all
        },
        getDescription: (state) => {
            return state.description
        }
    },
    mutations: {
        setAll: (state, payload) => {
            state.all = Object.assign(state.all, payload)
        },
        setDescription: (state, payload) => {
            state.description =  String(payload)
        },
        setCalculete: (state, playload) => {
            state.calculeteBalance = playload
        }
        ,
    },
    actions: {
        calculete(context) {
            const all = context.getters.getAll;
            context.commit('setCalculete', (((convertFloat(all.totalfamilyincome) - convertFloat(all.alimony)) * all.educationexpenditureindex * all.housingexpensesindex * all.healthtotal) / parseInt(all.familymembers)).toFixed(2))
        }
    }

}